import { FC, memo } from 'react';

import { AppAutocomplete, AwesomeNodePath } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompletePageNodesQuery } from '@/modules/Pages';

interface Props extends AppAutocompleteComponentProps {
  siteId: string;
}

export const RedirectPageFromAutocomplete: FC<Props> = memo(({ siteId, ...props }) => {
  return (
    <AppAutocomplete<typeof useAutocompletePageNodesQuery>
      { ...props }
      queryArgs={ [siteId] }
      optionItemRender={ ({ path }) => <AwesomeNodePath path={ path }/> }
      options={ (data) => parseSelectData(data, { value: 'id', label: 'path' }) }
      notFoundDescription="Немає сторінок для цього сайту"
      placeholder="Оберіть існуючу сторінку сайту"
      query={ useAutocompletePageNodesQuery }
    />
  );
});
